export default "/48fa36d8db67bcc1a85b29aa56b388db.jpg";